export default "__VITE_ASSET__5087657a__"